<footer class="site-footer" role="contentinfo">
  <section class="site-footer__top">
    <div class="site-footer__container">
      <nav class="site-footer__links" aria-label="Footer">
        <ul class="list list--inline">
          <li class="list__item">
            <a class="site-footer__link" href="https://www.stoke.gov.uk/contact">Contact us</a>
          </li>
          <li class="list__item">
            <a class="site-footer__link" href="https://www.stoke.gov.uk/email_updates">Email updates</a>
          </li>
          <li class="list__item">
            <a class="site-footer__link" href="https://www.stoke.gov.uk/accessibility/settings">Accessibility</a>
          </li>
          <li class="list__item">
            <a class="site-footer__link" href="https://www.stoke.gov.uk/accessibility">Accessibility Statement</a>
          </li>
          <li class="list__item">
            <a class="site-footer__link" href="https://www.stoke.gov.uk/SiteFeedback">Feedback</a>
          </li>
        </ul>
      </nav>
    </div>
  </section>

  <section class="site-footer__bottom">
    <div class="site-footer__container">
      <nav class="site-footer__social" aria-label="Social media">
        <ul class="list list--inline">
          <li class="list__item">
            <a class="site-footer__social-link" href="https://www.facebook.com/sotcitycouncil/" aria-label="Facebook">
              <fa-icon [icon]="faFacebookF"></fa-icon>
            </a>
          </li>
          <li class="list__item">
            <a class="site-footer__social-link" href="https://www.youtube.com/user/StokeOnTrentCouncil" aria-label="YouTube">
              <fa-icon [icon]="faYoutube"></fa-icon>
            </a>
          </li>
          <li class="list__item">
            <a class="site-footer__social-link" href="https://twitter.com/SoTCityCouncil" aria-label="Twitter">
              <fa-icon [icon]="faX"></fa-icon>
            </a>
          </li>
          <li class="list__item">
            <a class="site-footer__social-link" href="https://www.flickr.com/photos/stoke-on-trent/" aria-label="Flickr">
              <fa-icon [icon]="faFlickr"></fa-icon>
            </a>
          </li>
        </ul>
      </nav>

      <address class="site-footer__address">
        <span>Stoke-on-Trent,</span> Civic Centre, Glebe Street, Stoke-on-Trent, ST4 1HH
      </address>

    </div>
  </section>
</footer>
